import type { QueryClient } from "@tanstack/react-query";
import { NOTIFICATIONS_QUERY_KEY } from "@/features/notifications/constants/notifications.constants";

export const notificationsInvalidationService = {
  invalidateNotifications: async (queryClient: QueryClient): Promise<void> => {
    await queryClient.invalidateQueries({ queryKey: NOTIFICATIONS_QUERY_KEY });
  },
};
